export default __webpack_public_path__ + "static/media/guild-total.e7aa9630.svg";